import { create } from 'zustand';
import React from 'react';

// Simple, stable Zustand store for funding
const useFundingStore = create((set, get) => ({
  // State
  fundingApplications: [],
  loading: false,
  error: null,

  // Actions
  createFundingApplication: (applicationData) => {
    const id = `funding_${Date.now()}_${Math.random()?.toString(36)?.substr(2, 9)}`;
    const application = {
      id,
      childId: applicationData?.childId,
      fundingType: applicationData?.fundingType || '30hours',
      status: applicationData?.status || 'pending',
      startDate: applicationData?.startDate,
      endDate: applicationData?.endDate,
      hoursAwarded: applicationData?.hoursAwarded || 0,
      createdAt: new Date()?.toISOString(),
      updatedAt: new Date()?.toISOString()
    };
    
    set(state => ({
      fundingApplications: [...state?.fundingApplications, application]
    }));
  },

  updateFundingApplication: (id, updates) => {
    set(state => ({
      fundingApplications: state?.fundingApplications?.map(app => 
        app?.id === id 
          ? { ...app, ...updates, updatedAt: new Date()?.toISOString() }
          : app
      )
    }));
  },

  // Helper functions
  getFundingByChild: (childId) => {
    const state = get();
    return state?.fundingApplications?.filter(app => app?.childId === childId) || [];
  },

  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error })
}));

export default useFundingStore;

// Simple hook that uses stable selectors
export const useFunding = () => {
  const fundingApplications = useFundingStore(state => state?.fundingApplications);
  const loading = useFundingStore(state => state?.loading);
  const error = useFundingStore(state => state?.error);
  const createFundingApplication = useFundingStore(state => state?.createFundingApplication);
  const updateFundingApplication = useFundingStore(state => state?.updateFundingApplication);
  const getFundingByChild = useFundingStore(state => state?.getFundingByChild);
  const setLoading = useFundingStore(state => state?.setLoading);
  const setError = useFundingStore(state => state?.setError);

  return {
    fundingApplications,
    loading,
    error,
    createFundingApplication,
    updateFundingApplication,
    getFundingByChild,
    setLoading,
    setError
  };
};
function RegionType(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: RegionType is not implemented yet.', args);
  return null;
}

export { RegionType };